import { SpinatLeft, SpinatRight } from './SpinatComponent.styled';
export const SpinatComponent = () => {
  return (
    <>
      <SpinatLeft></SpinatLeft>
      <SpinatRight></SpinatRight>
    </>
  );
};
